import React from "react";
import styles from "./Loader.module.css";

const Loader = ({ size }) => {
  return <div className={`${styles.loader} ${styles[size]}`} />;
};

export default Loader;
